export default "__VITE_ASSET__DoOgtInj__"